// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__11X5D","tab":"ProcedureTabs_tab__1aHyY"};